import { Dialog, Portal, CloseButton } from "@chakra-ui/react";
import useCloseModal from "hooks/useCloseModal";
import { useStores } from "stores/rootStore";
import ProductInfo from "@features/marketplace/catalog/ProductInfo";
import { allProducts } from "helpers/fakeData";
import { observer } from "mobx-react-lite";

const ProductModal = () => {
  const { pageStore, marketPlaceStore } = useStores();
  const onClose = useCloseModal();
  const isOpen = pageStore.isProductModalOpen();
  const productId = marketPlaceStore.selectedProductId;
  const product = productId
    ? allProducts.find((p) => p.id === productId)
    : null;

  return (
    <Dialog.Root size="lg" lazyMount open={isOpen} onOpenChange={onClose}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          {productId != null && (
            <Dialog.Content>
              <Dialog.Header>
                <Dialog.Title>{product?.title}</Dialog.Title>
              </Dialog.Header>
              <Dialog.Body p={10}>
                <ProductInfo productId={productId} onAddToCart={onClose} />
              </Dialog.Body>
              <Dialog.CloseTrigger asChild>
                <CloseButton size="sm" />
              </Dialog.CloseTrigger>
            </Dialog.Content>
          )}
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default observer(ProductModal);
